module.exports = __webpack_public_path__ + "static/media/atu.9eff95dd.png";